<template>
  <div :class="componentClassName">
    <a-page-heading>契約情報確認・変更</a-page-heading>
    <m-section>
      <m-action-card title="契約電話番号" icon="code" :header-border="true">
        <div class="t-contract-edit-phone-number__fields">
          <div class="t-contract-edit-phone-number__instruction">
            <a-text>
              ご契約している電話番号の追加・削除が行えます。<br />
              電話番号の料金については
              <a-button variant="text" color="primary" :href="pricingUrl">こちら</a-button>
            </a-text>
            <a-caption-list>
              <li>契約名義の050番号は削除できません</li>
            </a-caption-list>
          </div>

          <div class="t-contract-edit-phone-number__numbers">
            <a-summary-item-header text="電話番号" />
            <div class="t-contract-edit-phone-number__list">
              <div
                v-for="(item, index) in currentNumberList"
                :key="index"
                class="t-contract-edit-phone-number__list-item"
              >
                <div class="t-contract-edit-phone-number__list-item-phone-number">
                  {{ item.phone_number }}
                </div>
                <div v-if="!item.default" class="t-contract-edit-phone-number__list-item-action">
                  <a-button
                    :inline="true"
                    variant="round"
                    color="grey"
                    size="small"
                    icon="trash"
                    label="削除"
                    @click="handleRowPhoneNumberRemove(index)"
                  />
                </div>
              </div>
            </div>
            <div class="t-contract-edit-phone-number__numbers-control">
              <a-button
                :inline="true"
                variant="fill"
                color="primary"
                size="small"
                icon="plus"
                icon-color="white"
                label="新規追加"
                @click="handleAddPhoneNumber"
              />
            </div>
          </div>
        </div>
        <m-form-action-buttons>
          <a-button variant="outlined" color="primary" @click="handleCancelClick">戻る</a-button>
        </m-form-action-buttons>
      </m-action-card>
    </m-section>
  </div>
  <teleport to="body">
    <o-modal
      id="ContractEditPhoneNumber_confirmModal"
      v-model:visible="removePhoneNumberDialogVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      @close="handleCancelRemovePhoneNumber"
    >
      <template #title>料金確認</template>
      <a-text :center="true">
        <!-- eslint-disable -->
        <span v-html="removePhoneNumberConfirmationMessage" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          variant="outlined"
          color="primary"
          label="いいえ"
          size="small"
          @click="handleCancelRemovePhoneNumber"
        />
        <a-button variant="block" color="primary" label="はい" size="small" @click="handleConfirmRemovePhoneNumber" />
      </template>
    </o-modal>
  </teleport>
  <teleport to="body">
    <o-modal
      id="ContractEditPhoneNumber_confirmationModal"
      v-model:visible="confirmPhoneNumberDialogVisible"
      class="o-modal-confirm-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      @close="handleCancelConfirmPhoneNumber"
    >
      <template #title>料金確認</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="confirmPhoneNumberConfirmationMessageText" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          variant="outlined"
          color="primary"
          label="いいえ"
          size="small"
          @click="handleCancelConfirmPhoneNumber"
        />
        <a-button variant="block" color="primary" label="はい" size="small" @click="handleConfirmConfirmPhoneNumber" />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import AText from '@/components/atoms/text';
import ACaptionList from '@/components/atoms/caption-list';
import OModal from '@/components/organisms/modal';
import ASummaryItemHeader from '@/components/atoms/summary-item-header';
import * as Handlebars from 'handlebars';

export default {
  name: 't-contract-edit-phone-number',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    MFormActionButtons,
    AText,
    ACaptionList,
    OModal,
    ASummaryItemHeader,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    pricingUrl: {
      type: String,
      default: '#',
    },
    numberList: {
      type: Array,
      default: new Array(0),
    },
    handleCancelClick: {
      type: Function,
      default: () => {},
    },
    handleRemovePhoneNumber: {
      type: Function,
      default: () => {},
    },
    handleConfirmAddPhoneNumber: {
      type: Function,
      default: () => {},
    },
    removePhoneNumberConfirmationTitle: {
      type: String,
      default: '',
    },
    removePhoneNumberConfirmationMessageText: {
      type: String,
      default: '',
    },
    confirmPhoneNumberConfirmationTitle: {
      type: String,
      default: '',
    },
    confirmPhoneNumberConfirmationMessageText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentNumberList: [],
      removePhoneNumberDialogVisible: false,
      currentRemovePhoneNumberIndex: null,
      confirmPhoneNumberDialogVisible: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-contract-edit-phone-number');
      return `${baseClassName} ${this.class}`.trim();
    },
    removePhoneNumberConfirmationMessage() {
      const currentNumber = this.currentNumberList[this.currentRemovePhoneNumberIndex];
      const template = Handlebars.compile(this.removePhoneNumberConfirmationMessageText);
      return template(currentNumber);
    },
  },
  watch: {
    numberList: {
      handler(val) {
        this.currentNumberList = val;
      },
      deep: true,
    },
  },
  mounted() {
    if (this.numberList) {
      this.currentNumberList = this.numberList;
    }
  },
  methods: {
    handleRowPhoneNumberRemove(index) {
      this.currentRemovePhoneNumberIndex = index;
      this.removePhoneNumberDialogVisible = true;
    },
    handleConfirmRemovePhoneNumber() {
      this.handleRemovePhoneNumber(this.currentRemovePhoneNumberIndex);
      this.removePhoneNumberDialogVisible = false;
      this.currentRemovePhoneNumberIndex = null;
    },
    handleCancelRemovePhoneNumber() {
      this.removePhoneNumberDialogVisible = false;
      this.currentRemovePhoneNumberIndex = null;
    },
    handleAddPhoneNumber() {
      this.confirmPhoneNumberDialogVisible = true;
    },
    handleConfirmConfirmPhoneNumber() {
      this.handleConfirmAddPhoneNumber();
      this.confirmPhoneNumberDialogVisible = false;
    },
    handleCancelConfirmPhoneNumber() {
      this.confirmPhoneNumberDialogVisible = false;
    },
  },
};
</script>
